import { Component, OnInit, Inject, OnDestroy } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';
import { UserHelper } from '@helpers/user.helper';
import { Router } from '@angular/router';

@Component({
  selector: 'payout-dialog',
  templateUrl: '../sharedTemplates/payout.dialog.html',
})
export class PayoutDialog {
  constructor(
    public dialogRef: MatDialogRef<PayoutDialog>,
    private _ApiService: ApiService,
    public _LocalizationService: LocalizationService,
    public _UserHelper: UserHelper,
    private _router: Router
  ) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

  bookingLoginResult() {
    this._ApiService.bookingLoginResult().then();
  }

  goToSports() {
    this._router.navigate(['/sports']).then(x => {
      this.dialogRef.close();
    });
  }
}
